import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, GridLegacy as Grid } from "@mui/material";
import { FC, useEffect } from "react";
import { useTranslation } from 'react-i18next';

import { ICriteria } from "./common/types";
import { ReportParameterDatePart } from "../../../logic/api";
import { useUserParams } from '../../../context/user-params-context';

interface IIntervalCriteriaConfig {
  defaultValue?: ReportParameterDatePart;
  allowedValues?: ReportParameterDatePart[];
}

export const IntervalSelector: FC<ICriteria<IIntervalCriteriaConfig>> = ({ config }) => {
  const { userParams, setUserParams, clearParams } = useUserParams();
  const { t } = useTranslation();

  const defaultValue = config?.defaultValue ?? ReportParameterDatePart.Day;
  const allowedValues = config?.allowedValues ?? [
    ReportParameterDatePart.Hour,
    ReportParameterDatePart.Day,
    ReportParameterDatePart.Week,
    ReportParameterDatePart.Month
  ];

  useEffect(() => {
    setUserParams({ "@u_interval": defaultValue });

    return () => {
      clearParams(['@u_interval']);
    };
  }, []);

  const handleChange = ({ target: { value } }: SelectChangeEvent) => {
    setUserParams({ "@u_interval": Number(value) });
  };

  return (
    <Grid item sm={4} md={2}>
      <FormControl fullWidth size="small" sx={{ minWidth: 160 }}>
        <InputLabel id="interval-select-label">
          {t("input.criteria.labels.interval")}
        </InputLabel>
        <Select
          labelId="interval-select-label"
          id="interval-select"
          value={String(userParams["@u_interval"] ?? defaultValue)}
          label={t("input.criteria.labels.interval")}
          onChange={handleChange}
        >
          {allowedValues.includes(ReportParameterDatePart.Hour) && (
            <MenuItem value={ReportParameterDatePart.Hour}>{t("input.criteria.options.hour")}</MenuItem>
          )}
          {allowedValues.includes(ReportParameterDatePart.Day) && (
            <MenuItem value={ReportParameterDatePart.Day}>{t("input.criteria.options.day")}</MenuItem>
          )}
          {allowedValues.includes(ReportParameterDatePart.Week) && (
            <MenuItem value={ReportParameterDatePart.Week}>{t("input.criteria.options.week")}</MenuItem>
          )}
          {allowedValues.includes(ReportParameterDatePart.Month) && (
            <MenuItem value={ReportParameterDatePart.Month}>{t("input.criteria.options.month")}</MenuItem>
          )}
        </Select>
      </FormControl>
    </Grid>
  );
};

export default IntervalSelector;
